<template>
    <div class="trophy-circle flex flex-center-vh relative mimic-title"
         :style="[{ background: trophy.background }, { flexBasis: size + 'px'}, { minWidth: size + 'px'}, { height: size + 'px'}, { border: borderWidth + 'px solid ' + trophy.border}, { color: trophy.color}, { fontSize: (size / 3) + 'px'}]">
        <template v-if="trophy.image && trophy.image !== '/img/image.resized.jpg'">
            <img :src="trophy.image">
        </template>
        <template v-else-if="trophy.uploads && trophy.uploads.length > 0 && trophy.uploads[0].filename !== '/img/image.resized.jpg'">
            <img :src="trophy.uploads[0].url">
        </template>
        <i v-else :class="trophy.icon"></i>

        <div v-if="trophy.activatable == 1 && trophy.progress == 100 && activeTrophy.id !== trophy.id && !displayOnly || trophy.activatable == 1 && trophy.category === 'custom' && activeTrophy.id !== trophy.id && !displayOnly" class="active-trophy-toggle absolute align-center hover no-select" @click="setActiveTrophy(trophy)" >
            <i class="fa fa-check"></i>
        </div>

        <span v-if="showTooltip">{{ trophy.title }}</span>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'TrophyCircle',

        props: {
            trophy: {
                required: true,
            },
            size: {
                default: 75,
            },
            displayOnly: {
                default: false,
            },
            showTooltip: {
                default: true,
            },
        },

        computed: {
            ...mapState([
                'activeTrophy',
            ]),

            borderWidth() {
                return parseInt(this.size / 15);
            }
        },

        methods: {
            setActiveTrophy(trophy) {
                this.$store.dispatch('storeActiveTrophy', trophy);
            }
        },
    }
</script>